import { render, staticRenderFns } from "./TwoRows.vue?vue&type=template&id=6ed45255&"
import script from "./TwoRows.vue?vue&type=script&lang=js&"
export * from "./TwoRows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports